import { Injectable } from '@angular/core';

export const LUMPSUM_CONSTRAINTS = {
  principal: { min: 1_000, max: 100_000_000, step: 1_000 },
  rate:      { min: 1,     max: 30,          step: 0.1   },
  tenureYears: { min: 1,   max: 40,          step: 1     }
} as const;

export interface LumpsumYearRow {
  year: number;
  invested: number;
  balance: number;
}

export interface LumpsumResult {
  years: LumpsumYearRow[];
  totalInvested: number;
  totalGain: number;
  maturityValue: number;
}

@Injectable({ providedIn: 'root' })
export class LumpsumCalculatorService {

  calculate(principal: number, annualRate: number, tenureYears: number): LumpsumResult {
    const r = annualRate / 100;

    const years: LumpsumYearRow[] = [];
    for (let y = 1; y <= tenureYears; y++) {
      years.push({ year: y, invested: principal, balance: principal * Math.pow(1 + r, y) });
    }

    const maturityValue = years.length ? years[years.length - 1].balance : principal;

    return { years, totalInvested: principal, totalGain: maturityValue - principal, maturityValue };
  }
}
